"use strict"

class WC_Product_Reviews_Pro

	$ = jQuery

	##
	# @todo UPDATES REPO NOTE: this file is outdated, but we haven't received the new one from support yet
	# Constructor
	##
	constructor: ( options ) ->
		if ( 'undefined' == typeof options )
			return

		@options = options

		# Perhaps a contribution type has been preselected via URL?
		comment_type = if window.location.hash and window.location.hash.indexOf( 'share' ) is 0 then window.location.hash.split( '-' )[1] else null
		@options.comment_type = @options.comment_type || comment_type

		this.initializeModal()

		this.initializeTabs()
		this.initializeRadioButtons()
		this.initializeAttachmentFields()
		this.initializeRatingFields()
		this.initializeFieldToggler()
		this.initializeValidation()

		this.initializeVoting()
		this.initializeNotifications()
		this.initializeFlagging()
		# this.initializeTips()

		this.initializeFilter()
		this.initializeRatingFilter()

		this.initializeReviewEditing()
		this.initializeDefaultReviewEditing()
		this.initializeReviewUpdating()
		this.checkReviewUpdated()
		this.removeReviewAttachment()
		this.emptyReviewAttchmentURL()
		this.checkGuestSaveReview()

		this.initializeGuestWatch()
		this.submitGuestWatch()

		# Custom code to add more feature for review pro
		this.customCodeFeatures()


	##
	# Filter contributions when changing the contribution type
	##
	initializeFilter: =>

		$( '.contributions-filter select' ).on 'change', ( e ) =>
			$target = $( e.currentTarget )
			this.filterContributions( $target.val() )

		$( '.js-clear-filters' ).on 'click', ( e ) ->
			e.preventDefault()
			$( '.contributions-filter select' ).val( '' ).trigger( 'change' )


	##
	# Filter contributions when clicking on a rating filter
	##
	initializeRatingFilter: =>

		$( '#reviews .product-rating-details a' ).on 'click', ( e ) =>
			e.preventDefault()
			$target = $( e.currentTarget )
			$( '.contributions-filter select' ).val( 'comment_type=review' )
			this.filterContributions( decodeURIComponent( $target.attr( 'href' ) ).split( 'comments_filter=' )[1].split( '#' )[0] )


	##
	# Filter contributions via AJAX
	##
	filterContributions: ( filter ) =>

		$( '#contributions-list-title' ).text( @options.i18n.loading )
		$( '#contributions-list .contributions-container' ).empty().addClass( 'loading' )

		$.get @options.ajax_url, {
			action:		  'wc_product_reviews_pro_contributions_list'
			product_id:	  @options.product_id,
			comments_filter: filter
		}, ( response ) =>
			$( '#contributions-list' ).html( response )

			this.hideFlagForms()
			this.initializeFieldToggler()
			# this.initializeTips()

		if ( filter )
			$( '.js-clear-filters' ).show()
		else
			$( '.js-clear-filters' ).hide()


	##
	# Initialize radio buttons
	#
	# Make the radio buttons behave somewhat like checkboxes
	# by unchecking when clicking a checked radio
	##
	initializeRadioButtons: ->

		$( "#reviews" ).on 'click', ".form-contribution input[type='radio']", ( e ) ->

			target   = e.currentTarget
			$target  = $( target )
			$row	 = $target.closest( '.form-row' )
			required = $row.hasClass( 'validate-required' )

			# Bail out if the field is required
			if required
				return

			if target.value is $row.attr( 'data-prev-value' )
				$target.prop( 'checked',false ).trigger 'change'
				$row.attr( 'data-prev-value', '' )
			else
				$row.attr( 'data-prev-value', target.value )


	##
	# Initialize contribution type tabs
	#
	# Handles switching between the tabs
	##
	initializeTabs: =>

		@$contributionTabs = $( '.contribution-form-wrapper' )

		if @options.comment_type and @options.comment_type isnt 'contribution_comment'
			this.activateTab( @options.comment_type )

		# Switch between contribution types
		$( '.js-switch-contribution-type' ).on 'click', ( e ) =>

			e.preventDefault()
			$target = $( e.currentTarget )
			this.activateTab( $target.attr( 'href' ).split( '-' )[1] )


	##
	# Activate the tab for the provided contribution/comment type
	##
	activateTab: ( type ) =>

		# @$contributionTabs.removeClass( 'active' )
		@$contributionTabs.filter( '#' + type + '_form_wrapper' ).addClass( 'active' )

		$( '.js-switch-contribution-type[href="#share-' + type + '"]' )
			.addClass( 'active' )
			.siblings( '.active' )
			.removeClass( 'active' )


	##
	# Initialize review rating field
	##
	initializeRatingFields: ->

		$( '#review_rating_field' ).each ( index, field ) ->

			$field = $( field )

			# Create a star label container
			$starLabel = $( '<span class="star-label" style="font-size: 0;" data-selected-text="" />' )
			$field.append( $starLabel )

			# Switch star label on hover
			$field.find( 'label.checkbox' ).each ( index, label ) ->
				$label = $( label )
				$label.hover ( -> $starLabel.text( $label.text() ) ), ->
					$starLabel.text( $starLabel.data( 'selected-text' ) )

			# Set star label to currently selected option's text
			$field.find( 'input' ).on 'change', ->
				text = $(this).siblings( 'label.checkbox[for="review_rating_' + $(this).val() + '"]' ).text()
				$starLabel.text( text ).data( 'selected-text', text )


	##
	# Initialize attachment fields
	##
	initializeAttachmentFields: =>

		# Add attachment source toggler, if necessary
		$( '.form-contribution .attachment-url' ).each ( index, element ) ->

			$element   = $( element )
			$form      = $element.closest( 'form' )
			$fileField = $form.find( '.attachment-file' )

			if ( $fileField.length )
				$element.add( $fileField ).prepend( '<a href="#" class="toggle-attachment-source"></a>' )

		# Attachment type selector
		$( '.form-contribution .attachment-type' ).each ( index, element ) =>

			$element = $( element )
			$form = $element.closest( 'form' )
			contributionType = $form.find( 'input[name="comment_type"]' ).val()

			$attachmentTypeToggler = $element.find( 'input' )
			$urlField  = $form.find( '.attachment-url' )
			$fileField = $form.find( '.attachment-file' )

			# Hide URL if this is not a media-specific contribution typoe
			if ( $.inArray( contributionType, ['video', 'photo'] ) is -1 )
				$urlField.hide()

			# Always hide the file field as it's not preferred
			$fileField.hide()

			setTogglerTexts = ( type ) =>
				$urlField.find( '.toggle-attachment-source' ).text( @options.i18n[ 'attach_' + type + '_file' ] )
				$fileField.find( '.toggle-attachment-source' ).text( @options.i18n[ 'attach_' + type + '_url' ] )

			# Set attachment source toggler text, if attachment type is known
			if ( $attachmentTypeToggler.val() )
				setTogglerTexts( $attachmentTypeToggler.val() )

			# Toggle attachment source toggler text, if attachment type changes.
			# Also show/hide the attachment fields, if necessary
			$attachmentTypeToggler.on( 'change', ( e ) ->

				target  = e.currentTarget
				$target = $( target )
				type	= target.value
				checked = $target.is( ':checked' )

				if ( checked and type )
					setTogglerTexts( type )

					# Hide the file field and attachment selector, if type is 'video'
					if ( 'video' is type )
						$fileField.hide()
						$urlField.find( '.toggle-attachment-source' ).hide()
					else
						$urlField.find( '.toggle-attachment-source' ).show()

					# Display URL field, if none of the attachment fields are visible
					if ( ! $urlField.is( ':visible' ) and ! $fileField.is( ':visible' ) )
						$urlField.slideDown( 'fast' )


				else
					$urlField.slideUp( 'fast' )
					$fileField.slideUp( 'fast' )
			).each ( index, element ) =>
				$element = $( element )
				type     = element.value
				$element
					.next( 'label.checkbox' )
					.attr( 'title', @options.i18n[ 'attach_a_' + type ] )
					.addClass( 'js-tip' )


			# Hide the main label for this control
			$element.find( 'label:first-child' ).hide()

			# Toggle attachment source
			$form.find( '.toggle-attachment-source' ).on 'click', ( e ) ->
				e.preventDefault()

				$fileField.slideToggle( 'fast' )
				$urlField.slideToggle( 'fast' )

			# Smoke-test for correct file type
			$fileField.on 'change', 'input', ( e ) =>
				target  = e.currentTarget
				$target = $( target )
				$target.siblings( '.wc-product-reviews-pro-validation-error' ).remove()

				allowed = target.files[0].type.match( 'image.*' )

				if ! allowed
					$target.after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.file_not_allowed + '</span>' )


	##
	# Initialize contribution form field toggler
	#
	# Hides all fields except the first and shows all
	# hidden fields when the first field receives focus
	#
	# This method needs to be called again if reloading contributions via AJAX,
	# as this needs to be run for each comment form as well
	##
	initializeFieldToggler: =>

		# Show contribution fields when clicking on title field
		$( '.form-contribution:not(.field-toggler-initialized)' ).each ( index, element ) =>

			$element = $( element )
			contribution_type = $element.find( 'input[name="comment_type"]' ).val()

			# move the rating below the review if it's not required
			$( '.star-rating-selector:not(.validate-required )' ).insertAfter( '#review_comment_field' )

			# Skip this, if this form is for the current comment/contribution type
			if ( @options.comment_type is contribution_type )
				return

			# First, hide all fields, except the first
			$element.find( '.form-row:not(:first)' ).hide()
			$element.find( '.wc-product-reviews-pro-form-submit-row' ).hide()

			# Bind a one-time action to the first field focus event to show
			# all the oter fields
			$element.find( '.form-row:first' ).find( 'input, textarea, select' ).one 'focus change', ( e ) ->
				$target = $( e.currentTarget )
				$form   = $target.closest( 'form' )
				type    = $form.find( 'input[name="comment_type"]' ).val()

				# Only show attachment source fields if media-specific contribution type
				if 'photo' isnt type and 'video' isnt type
					$form.find( '.form-row:hidden:not(:contains(.input-hidden)):not(.attachment-source)' ).slideDown( 'fast' )
					$form.find( '.wc-product-reviews-pro-form-submit-row:hidden:not(:contains(.input-hidden)):not(.attachment-source)' ).slideDown( 'fast' )
				else if 'photo' is type
					$form.find( '.form-row:hidden:not(:contains(.input-hidden)):not(.attachment-file)' ).slideDown( 'fast' )
					$form.find( '.wc-product-reviews-pro-form-submit-row:hidden:not(:contains(.input-hidden)):not(.attachment-file)' ).slideDown( 'fast' )
				else
					$form.find( '.form-row:hidden:not(:contains(.input-hidden))' ).slideDown( 'fast' )
					$form.find( '.wc-product-reviews-pro-form-submit-row:hidden:not(:contains(.input-hidden))' ).slideDown( 'fast' )

			# Indicate that this form has field toggler initialized
			$element.addClass( 'field-toggler-initialized' )


	##
	# Validate contribution
	#
	# TODO: Implement validation
	##
	initializeValidation: =>

		$( '#reviews' ).on 'submit', '.form-contribution', ( e ) =>

			e.preventDefault()
			$form = $( e.currentTarget )

			# Get the type
			type = $form.find( 'input[name="comment_type"]' ).val()

			# Remove previous validation errors
			$form.find( '.wc-product-reviews-pro-validation-error' ).remove()

			# Max upload size for attachments
			max_upload_size = @options.file_size_max

			# Validate fields
			errors = 0
			$form.find( 'input,select,textarea' ).each ( index, element ) =>

				$element = $( element )
				key      = $element.attr( 'name' )
				value    = $element.val()

				required = $element.closest( '.form-row' ).hasClass( 'validate-required' )

				if ( required and key isnt 'review_rating' and ! value )
					$element.after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_required + '</span>' )
					errors++

				switch ( key )
					when type + '_comment'

						$textarea = $element
						minCount = $textarea.data( 'min-word-count' )
						maxCount = $textarea.data( 'max-word-count' )

						if ( minCount || maxCount )

							count = $.trim( $textarea.val() ).split(" ").length

							if minCount && count < minCount
								$textarea.after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_too_short.replace(/%d/g, minCount) + '</span>' )
								errors++

							else if maxCount && count > maxCount
								$textarea.after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_too_long.replace(/%d/g, maxCount) + '</span>' )
								errors++

					when type + '_attachment_file'

						$file_input = $element
						file_size  = null

						# Get file size if user added one and browser supports File API
						if ( FileReader? and element.files.length > 0 )
							file_size = element.files[0].size

						if ( file_size? and file_size > max_upload_size )
							$file_input.after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_file_size_max + '</span>' )
							errors++

			# Make sure that at least one of file or url is provided
			if ( 'photo' is type )
				url_value  = $form.find( '.attachment-url input' ).val()
				file_value = $form.find( '.attachment-file input' ).val()

				if ( !url_value and !file_value )
					$form.find( '.attachment-url input' ).after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_attach_file + '</span>' )
					$form.find( '.attachment-file input' ).after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_attach_file + '</span>' )

			# Stop here, if we have validation errors
			if ( errors )
				return

			submitForm = ->
				$form.get(0).submit()

			# Show login/register modal when user is not logged in
			if ! @options.is_user_logged_in and @options.comment_registration
				$( '.guest-switcher' ).data( 'target', 'form-contribution' )
				$( '#guest_login, .guest-switcher, .switcher .login' ).hide()
				$( '#customer_login, .switcher .register' ).show()

				this.showModal().one 'login', ->
					submitForm()
			else
				submitForm()


	##
	# Initialize voting
	##
	initializeVoting: =>

		# Upvote/downvote a contribution
		$( '#comments' ).on 'click', '.contribution-actions .vote', ( e ) =>

			e.preventDefault()

			$target    = $( e.currentTarget )
			type       = if $target.hasClass( 'vote-down' ) then 'negative' else 'positive'
			comment_id = $target.data( 'comment-id' )

			$feedback	    = $target.siblings( '.feedback' ).html( '' )
			$positive_count = $target.siblings( '.vote-count-positive' )
			$negative_count = $target.siblings( '.vote-count-negative' )

			# Whether this type of vote was already cast by the current user
			was_previous_vote = $target.hasClass( 'done' )

			# Perform ajax request to cast the vote
			castVote = =>
				$.ajax
					type: 'POST'
					url:  @options.ajax_url
					data:
						action:	 'wc_product_reviews_pro_vote'
						security:   @options.nonce
						vote:	   type
						comment_id: comment_id
					success: ( response ) =>

						$feedback.css( 'display', 'inline-block' )

						setTimeout( ->
							$feedback.fadeOut()
						, 2000 )

						if ! response.data || ! response.data.message
							return $feedback.text( @options.i18n.vote_failed ).addClass( 'error' )

						$feedback.text( response.data.message )

						if ( response.success )

							$feedback.removeClass( 'error' )
							$positive_count.text( '(' + response.data.positive_votes + ')' )
							$negative_count.text( '(' + response.data.negative_votes + ')' )

							# Remove previous vote indicator
							$target.removeClass( 'done' ).siblings( '.vote' ).removeClass( 'done' )

							if ( ! was_previous_vote )
								$target.addClass( 'done' )

							# Update comment karma text
							if ( response.data.positive_votes || response.data.negative_votes )
								karma = @options.i18n.comment_karma
									.replace( '%1$d', response.data.positive_votes )
									.replace( '%2$d', response.data.total_votes )
							else
								karma = ''

							$target.closest( '.comment_container' ).find( '.contribution-karma' ).text( karma )
						else
							$feedback.addClass( 'error' )

			# Show login/register modal when user is not logged in
			if ! @options.is_user_logged_in
				$( '.guest-switcher' ).data( 'target', 'vote' )
				$( '#guest_login, .guest-switcher, .switcher .login' ).hide()
				$( '#customer_login, .switcher .register' ).show()

				this.showModal().one 'login', ->
					castVote()
			else
				castVote()


	##
	# Initialize contribution subscription
	##
	initializeNotifications: =>

		$( '#comments' ).on 'click', '.contribution-actions .notifications', ( e ) =>

			e.preventDefault()

			$self = $( e.currentTarget )

			type        = if $self.hasClass( 'subscribe' ) then 'subscribe' else 'unsubscribe'
			comment_id  = $self.data( 'comment-id' )
			$feedback   = $self.siblings( '.feedback' ).html( '' )

			subscribe = =>
				$.ajax
					type: 'POST'
					url:  @options.ajax_url
					data:
						action:     'wc_product_reviews_pro_notify_replies'
						security:   @options.nonce
						manage:	    type
						user_id:    @options.user_id
						comment_id: comment_id
					success: ( response ) =>

						$feedback.css( 'display', 'inline-block' )

						setTimeout( ->
							$feedback.fadeOut()
						, 2000 )

						if ! response.data || ! response.data.message
							return $feedback.text( @options.i18n.subscribe_failed ).addClass( 'error' )

						$feedback.text( response.data.message )

						if ( response.success )

							$self.hide()

							if ( 'subscribe' == type )
								$self.parent().find( '.unsubscribe' ).show()
							else
								$self.parent().find( '.subscribe' ).show()

							$feedback.removeClass( 'error' )

						else

							$feedback.addClass( 'error' )

			# Show login/register modal when user is not logged in
			if ! @options.is_user_logged_in
				$( '.guest-switcher' ).data( 'target', 'notification' )
				$( '#guest_login, .switcher .login' ).hide()
				$( '#customer_login, .guest-switcher, .switcher .register' ).show()
				$( '#guest-comment-id' ).val( comment_id )

				this.showModal().one 'login', ->
					subscribe()
			else
				subscribe()

	##
	# Initialize the login/register modal
	#
	# Handles events related to opening and closing the modal as well as events
	# inside the modal
	##
	initializeModal: =>

		@$modal          = $modal          = $( '#wc-product-reviews-pro-modal' )
		@$overlay        = $overlay        = $( '#wc-product-reviews-pro-modal-overlay' )
		@$modalContainer = $modalContainer = $( '#wc-product-reviews-pro-modal-container' )

		# Close modal when clicking the close button
		$modal.find( 'a.close' ).on 'click', ( e ) =>
			e.preventDefault()
			this.hideModal()

		# Toggle login/register forms
		$modal.find( '.switcher a' ).on 'click', ( e ) ->
			e.preventDefault()
			$target = $( e.currentTarget )
			$target.closest( '.switcher' ).find( 'p' ).toggle()
			$modal.find( '.col-1, .col-2' ).toggle().filter(':visible').find( '.woocommerce-Input' ).first().focus()

		# Handle login form inside modal
		$modal.find( 'form.login' ).on 'submit', ( e ) =>
			e.preventDefault()

			$form    = $( e.currentTarget )
			$wpnonce = $form.find( '#woocommerce-login-nonce' ).val()

			$.post @options.ajax_url, {
				username: $form.find( '#username' ).val(),
				password: $form.find( '#password' ).val(),
				_wpnonce: $wpnonce,
				login: 1,
				_wc_product_reviews_pro_ajax_login: 1,
			}, ( response ) =>
				this.handleModalAjaxResponse( response, $form )

		# Handle register form inside modal
		$modal.find( 'form.register' ).on 'submit', ( e ) =>
			e.preventDefault()

			$form    = $( e.currentTarget )
			$wpnonce = $form.find( '#woocommerce-register-nonce' ).val()

			$.post @options.ajax_url, {
				email:    $form.find( '#reg_email' ).val(),
				username: $form.find( '#reg_username' ).val(),
				password: $form.find( '#reg_password' ).val(),
				register: $form.find( '[name="register"]' ).val(),
				_wpnonce: $wpnonce,
				_wc_product_reviews_pro_ajax_register: true,
			}, ( response ) =>
				this.handleModalAjaxResponse( response, $form )


		$( '#reviews' ).on 'click', '.js-wc-product-reviews-pro-show-login-modal', ( e ) =>
			e.preventDefault()

			# Show login/register modal when user is not logged in
			if ! @options.is_user_logged_in
				$( '.guest-switcher' ).data( 'target', 'js-wc-product-reviews-pro-show-login-modal' )
				$( '#guest_login, .guest-switcher, .switcher .login' ).hide()
				$( '#customer_login, .switcher .register' ).show()

				this.showModal().one 'login', ->
					window.location.assign( window.location.toString() + '#reviews' )
					window.location.reload()


	##
	# Hide flagging forms
	#
	# This method needs to be called again if reloading contributions via AJAX
	##
	hideFlagForms: ->
		$( '.contribution-flag-form' ).hide()

	##
	# Initialize flagging forms
	##
	initializeFlagging: =>

		# First, hide all flagging forms
		this.hideFlagForms()

		# Handle flag form toggling
		$( '#comments' ).on 'click', '.contribution-actions .js-toggle-flag-form', ( e ) ->

			e.preventDefault()
			$target = $( e.currentTarget )

			# Remove any previous flagging response messages
			$( '.flag-response' ).remove()

			# Show the flag form for the provided contribution
			comment_id = $target.data( 'comment-id' )
			$( 'form#flag-contribution-' + comment_id )
				.slideDown( 'fast' )
				.find( 'button' ).removeProp( 'disabled' )


		# Handle flagging a contribution
		$( '#reviews' ).on 'submit', '.contribution-flag-form', ( e ) =>

			e.preventDefault()

			$form = $( e.currentTarget )

			$form.find( 'button' ).attr( 'disabled', true )
			$feedback = $form.siblings( '.contribution-actions' ).find( '.feedback' ).html( '' )

			comment_id = $form.find( 'input[name="comment_id"]' ).val()
			reason     = $form.find( 'input[name="flag_reason"]' ).val()

			# Perform ajax request
			$.ajax
				type: 'POST'
				url:  @options.ajax_url
				data:
					action:	    'wc_product_reviews_pro_flag'
					security:   @options.nonce
					comment_id: comment_id,
					reason:	    reason
				success: ( response ) ->
					$form.slideUp( 'fast' ).find( 'button' ).removeAttr( 'disabled' )

					$feedback.show()

					setTimeout( ->
						$feedback.fadeOut()
					, 2000 )

					if ! response.data || ! response.data.message
						return $feedback.text( @options.i18n.flag_failed ).addClass( 'error' )

					$feedback.text( response.data.message )

					if ( response.success )
						$feedback.removeClass( 'error' )
						$form.prev( '.comment_container' ).find( '.js-toggle-flag-form' ).addClass( 'done' )
					else
						$feedback.addClass( 'error' )


	##
	# Initialize tips
	#
	# This needs to be called again when reloading via AJAX
	##
	###
	initializeTips: ->
		$( '.js-tip' ).tipTip
			attribute: 'title',
			fadeIn:	   50,
			fadeOut:   50,
			delay:	   200,
  ###

	##
	# Handle modal login/register ajax response
	##
	handleModalAjaxResponse: ( response, $form ) =>

		if response.success
			this.refreshNonce ( nonce ) =>
				@options.is_user_logged_in = true
				$form.prevAll( '.woocommerce-error' ).remove()
				this.hideModal().trigger( 'login' )

		else
			$form.prevAll( '.woocommerce-error' ).remove()
			$form.before( response?.data?.message ? @options.i18n.error_login_signup )


	##
	# Show the login/register modal
	##
	showModal: =>

		# Shorthand modal for better minification support
		$modal          = @$modal
		$overlay        = @$overlay
		$modalContainer = @$modalContainer

		# Close modal on ESC key press
		$( document ).on( 'keydown.modal', ( e ) =>
			if 27 is e.keyCode
				this.hideModal()
		)

		# Close modal when clicking on overlay
		$overlay.fadeIn( 100 ).on( 'click.modal', =>
			this.hideModal()
		)

		$( 'body' ).addClass( 'wc-prp-modal' )

		$modal.find( '.col-1' ).show().find( '.woocommerce-Input' ).first().focus()
		$modal.find( '.col-2' ).hide()

		$modal.trigger( 'showmodal' )


	##
	# Hide the login/register modal
	##
	hideModal: =>

		$( document ).off( 'keydown.modal' )

		$( 'body' ).removeClass( 'wc-prp-modal' )
		@$overlay.hide().off( 'click.modal' )

		@$modal.trigger( 'hidemodal' )


	##
	# Refresh nonce via AJAX
	##
	refreshNonce: ( cb ) =>
		$.get( @options.ajax_url, {
			action: 'wc_product_reviews_pro_refresh_nonce'
		} ).done( ( response ) =>
			@options.nonce = response?.data?.nonce
			@options.user_id = response?.data?.user_id
			cb( response?.data?.nonce )
		)


	##
	# Edit initialization
	##
	initializeReviewEditing: =>

		$( '#reviews' ).on 'click', '.edit-comment', ( e ) =>

			e.preventDefault()

			$elem        = $( e.currentTarget )
			$feedback    = $elem.siblings( '.feedback' ).html( '' )
			$comment_id	 = $elem.data( 'comment-id' )
			$product_id	 = $( 'input[name="comment_post_ID"]' ).val()
			$form_review = $( '.form-review' )

			$.ajax
				type:   'POST'
				url:   @options.ajax_url
				data:
					action:   'wc_product_reviews_pro_get_review'
					security:   @options.nonce
					comment_id:   $comment_id
					product_id:   $product_id
				success: ( response ) =>
					$form_review[ 0 ].reset()
					$form_review.find( '.review_attachment' ).remove()

					if ( response.success )
						$feedback.removeClass( 'error' )

						# Scroll to review form.
						$( 'html, body' ).animate( {
							scrollTop: $( "#review_form_wrapper" ).offset().top - 100
						}, 'medium' )

						$review = response.data.review

						# Filling up review title, content, etc. in the form.
						$( '#review_title' ).val( $review.title )
						$( '#review_comment' ).val( $review.content )
						$( '#comment_ID' ).val( $comment_id )

						$form_review.find( '.attachment-file' ).hide()
						$form_review.find( '.attachment-url' ).hide()

						# Checking if rating is available for the comment.
						if ( '' != $review.rating )
							$( '#review_rating_' + $review.rating ).prop( 'checked', true )

						# Checking if comment has any attachment.
						if ( '' != $review.attachment_type )
							$( 'input[name="review_attachment_type"]' ).prop( 'checked', false )
							$( '#review_attachment_type_' + $review.attachment_type ).prop( 'checked', true )
							$( '#review_attachment_type_field' ).data( 'prev-value', $review.attachment_type )

						$attachment_url = ':not(.attachment-url)'

						if ( '' != $review.attachment_url )
							$( '#review_attachment_url' ).val( $review.attachment_url )
							$attachment_url = ''

						$attachment_file = ':not(.attachment-file)'

						if ( '' != $review.attachment_id )
							$attachment_file = ''

							# Append attachment markup in the update review form.
							$remove_attachment 		= $( '<a>' ).addClass( 'remove_attachment' ).attr( 'href', '#' ).text( @options.i18n.remove_attachment )
							$attachment 					= $( '<img>' ).attr( 'src', $review.attachment_file_url )
							$attachment_container	= $( '<div>' ).addClass( 'review_attachment' ).html( $remove_attachment )

							$attachment_container.append( $attachment )

							$form_review.find( '.attachment-file' ).append( $attachment_container )

						if ( 'yes' == $review.subscribed )
							$( '#subscribe_to_replies' ).prop( 'checked', true )
						else
							$( '#subscribe_to_replies' ).prop( 'checked', false )

						$( '.star-rating-selector' ).removeClass( 'change-rating' )

						if ( $( '#review_form_wrapper' ).hasClass( 'loading' ) )
							$( '#review_form_wrapper' ).removeClass( 'loading' )

						# Displaying form elements.
						$form_review.find( '.form-row:hidden:not(:contains(.input-hidden))' + $attachment_url + $attachment_file ).slideDown( 'fast' )
						$form_review.find( '.wc-product-reviews-pro-form-submit-row:hidden:not(:contains(.input-hidden))' + $attachment_url + $attachment_file ).slideDown( 'fast' )
					else
						$feedback.addClass( 'error' )
						$feedback.text( response.data.message )

						setTimeout( ->
							$feedback.fadeOut()
						, 2000 )


	##
  # Updating review
	##
	initializeReviewUpdating: =>

		$( '.form-review' ).on 'click', '.update-review', ( e ) =>

			$review_content = $( '#review_comment' ).val()

			# Checking if review content is not empty before updating.
			if ( '' == $review_content )
				$( '#review_comment' ).after( '<span class="wc-product-reviews-pro-validation-error">' + @options.i18n.error_required + '</span>' )

				return

			$response          = $( '.form-review .response' )
			$review_title      = $( '#review_title' ).val()
			$comment_id        = $( '#comment_ID' ).val()
			$product_id        = $( 'input[name="comment_post_ID"]' ).val()
			$rating            = $( 'input[name="review_rating"]:checked' ).val()
			$attachment_url    = $( '#review_attachment_url' ).val()
			$remove_attachment = $( '.form-review .remove_attachment' ).length
			$file_changed      = 0

			# Checking if any file is attached or not.
			if ( 0 < $( '#review_attachment_file' ).length && 0 < $( '#review_attachment_file' )[ 0 ].files.length )
				$files = $( '#review_attachment_file' )[ 0 ].files[ 0 ]
				$file_changed = 1
			else
				$files = ''

			# Checking if user has selected any attachment type like photo/video.
			if ( $( 'input[name="review_attachment_type"]:checked' ).length > 0 )
				$attachment_type = $( 'input[name="review_attachment_type"]:checked' ).val()
			else
				$attachment_type = ''

			# Checking if user wants to subscribe for the replies.
			if ( $( '#subscribe_to_replies' ).is( ':checked' ) )
				$subscribed = 'yes'
			else
				$subscribed = 'no'

			# Creating form data.
			$form_data = new FormData()
			$form_data.append( 'action', 'wc_product_reviews_pro_update_review' )
			$form_data.append( 'security', @options.nonce )
			$form_data.append( 'review_title', $review_title )
			$form_data.append( 'review_content', $review_content )
			$form_data.append( 'comment_id', $comment_id )
			$form_data.append( 'product_id', $product_id )
			$form_data.append( 'rating', $rating )
			$form_data.append( 'attachment_url', $attachment_url )
			$form_data.append( 'attachment_type', $attachment_type )
			$form_data.append( 'delete_attachment', $remove_attachment )
			$form_data.append( 'files', $files )
			$form_data.append( 'file_changed', $file_changed )
			$form_data.append( 'subscribed', $subscribed )

			$.ajax
				type:   'POST'
				url:   @options.ajax_url
				data:   $form_data
				processData:   false
				contentType:   false
				success: ( response ) =>
					$response.text( response.data.message )
					$response.css( 'display', 'inline-block' )

					if ( response.success )
						$response.removeClass( 'error' )

						setTimeout( ->
							$uri = window.location.href

							if ( $uri.indexOf( '?' ) != -1 )
								$separator = "&"
							else
								$separator = "?"

							window.location.href = window.location.href + $separator + "updated=" + $comment_id
						, 2000 )
					else
						$response.addClass( 'error' )


	##
	# Check for review updated query param in URL.
	##
	checkReviewUpdated: =>
		$url     = window.location.href
		$regex   = new RegExp( "[?&]updated(=([^&#]*)|&|#|$)" )
		$results = $regex.exec( $url )

		if ( ! $results || ! $results[ 2 ] )
			return

		$comment_id = decodeURIComponent( $results[ 2 ].replace( /\+/g, " " ) )

		$( '.wc-tabs li' ).removeClass( 'active' )
		$( '.wc-tabs li.reviews_tab' ).addClass( 'active' )

		$( '.wc-tabs-wrapper .wc-tab' ).hide()
		$( '#tab-reviews' ).show()

		$( 'html, body' ).animate( {
			scrollTop: $( "#comment-" + $comment_id ).offset().top - 100
		}, 'medium' )

		window.history.replaceState( null, null, location.href.replace( /&?[&?]updated=([^&]$|[^&]*)/i, "" ) )


	##
	# Remove review attachment when updating.
	##
	removeReviewAttachment: ->
		$( '.form-review' ).on 'click', '.remove_attachment', ( e ) ->

			e.preventDefault()

			$( '.form-review' ).find( '.review_attachment' ).remove()


	##
	# Empty attachment URL when adding file from computer.
	##
	emptyReviewAttchmentURL: ->
		$( '#review_attachment_file' ).on 'change', ( e ) ->
			$( '#review_attachment_url' ).val( '' )


	##
	# Load recent review for editing.
	##
	initializeDefaultReviewEditing: ->
		$( '.form-review' ).on 'click', '.change-rating', ( e ) =>
			e.preventDefault()

			$( '#review_form_wrapper' ).addClass( 'loading' )

			$product_id	= $( 'input[name="comment_post_ID"]' ).val()

			$.ajax
				type:   'POST'
				url:   @options.ajax_url
				data:
					action:   'wc_product_reviews_pro_get_recent_review'
					security:   @options.nonce
					product_id:   $product_id
				success: ( response ) =>
					if ( response.success )
						$comment_id = response.data.review

						$( '#comment-' + $comment_id + ' .edit-comment' ).trigger( 'click' )


	##
	# Checking when Logged-out/Guest user tries to leave a review with an email tied to a registered user
	##
	checkGuestSaveReview: ->
		$( '.form-review' ).on 'click', 'button[type=submit]',  ( e ) =>

			# Checking if user is not logged in.
			if ! @options.is_user_logged_in
				e.preventDefault()

				if @options.comment_registration
					$( '.guest-switcher' ).data( 'target', 'form-contribution' )
					$( '#guest_login, .guest-switcher, .switcher .login' ).hide()
					$( '#customer_login, .switcher .register' ).show()

					this.showModal().one 'login', ->
						$( '.form-review' ).get(0).submit()
				else
					$email          = $( '#review_email' ).val()
					$review_content = $( '#review_comment' ).val()
					$name           = $( '#review_author' ).val()
					$product_id     = $( 'input[name="comment_post_ID"]' ).val()
					$response       = $( '.form-review .response' )

					# Preventing form submit when necessary fields are empty.
					if ( '' == $review_content || '' == $email || '' == $name )
						$( '.form-review' ).submit()

						return

					$.ajax
						type:   'POST'
						url:    @options.ajax_url
						data:
							action:   'wc_product_reviews_pro_check_review'
							security:   @options.nonce
							email:   $email
							product_id:   $product_id
						success: ( response ) =>
							if ( response.success )
								$response.removeClass( 'error' ).text( '' ).css( 'display', 'none' )

								$review_count = parseInt( response.data.count )

								if ( $review_count > 0 )
									$confirm = confirm( @options.i18n.review_update_confirmation )

									# Checking if user confirms about proceeding to update the review as a guest from the mail confirmation link.
									if ( $confirm )
										$review_title      = $( '#review_title' ).val()
										$rating            = $( 'input[name="review_rating"]:checked' ).val()
										$attachment_url    = $( '#review_attachment_url' ).val()
										$remove_attachment = $( '.form-review .remove_attachment' ).length

										# Checking if user has attached any file.
										if ( $( '#review_attachment_file' )[ 0 ].files.length > 0 )
											$files = $( '#review_attachment_file' )[ 0 ].files[ 0 ]
										else
											$files = ''

										# Checking if user has selected any attachment type.
										if ( $( 'input[name="review_attachment_type"]:checked' ).length > 0 )
											$attachment_type = $( 'input[name="review_attachment_type"]:checked' ).val()
										else
											$attachment_type = ''

										# Creating form data.
										$form_data = new FormData()
										$form_data.append( 'action', 'wc_product_reviews_pro_review_update_confirmation' )
										$form_data.append( 'security', @options.nonce )
										$form_data.append( 'email', $email )
										$form_data.append( 'review_title', $review_title )
										$form_data.append( 'review_content', $review_content )
										$form_data.append( 'product_id', $product_id )
										$form_data.append( 'rating', $rating )
										$form_data.append( 'attachment_url', $attachment_url )
										$form_data.append( 'attachment_type', $attachment_type )
										$form_data.append( 'delete_attachment', $remove_attachment )
										$form_data.append( 'files', $files )

										$.ajax
											type:   'POST'
											url:   @options.ajax_url
											data:   $form_data
											processData:   false
											contentType:   false
											success: ( response ) =>
												if ( response.success )
													$response.removeClass( 'error' ).text( response.data.message ).css( 'display', 'inline-block' )
												else
													$response.addClass( 'error' ).text( response.data.message ).css( 'display', 'inline-block' )

												setTimeout( ->
													$response.fadeOut()
												, 2000 )
								else
									$( '.form-review' ).submit()
							else
								# Checking if review update confirmation email is disabled error.
								if ( 'undefined' != typeof response.data.type )
									alert( response.data.message )
								else
									$response.addClass( 'error' ).text( response.data.message ).css( 'display', 'inline-block' )

									setTimeout( ->
										$response.fadeOut()
									, 2000 )


	##
	# Guest watch initialization
	##
	initializeGuestWatch: ->
		$( '#wc-product-reviews-pro-modal' ).on 'click', '.guest-link', ( e ) =>
			e.preventDefault()

			$( '#guest_login, #guest_login .col-1, .switcher .login, .switcher .register' ).show()
			$( '#customer_login, .guest-switcher' ).hide()

		$( '#wc-product-reviews-pro-modal' ).on 'click', '.switcher .register a', ( e ) =>
			e.preventDefault()

			$( '#guest_login, #customer_login .col-1, .switcher .register' ).hide()
			$( '#customer_login, #customer_login .col-2, .switcher .login' ).show()

			if ( 'notification' == $( '.guest-switcher' ).data( 'target' ) )
				$( '.guest-switcher' ).show()
			else
				$( '.guest-switcher' ).hide()

		$( '#wc-product-reviews-pro-modal' ).on 'click', '.switcher .login a', ( e ) =>
			e.preventDefault()

			$( '#guest_login, #customer_login .col-2, .switcher .login' ).hide()
			$( '#customer_login, #customer_login .col-1, .guest-switcher, .switcher .register' ).show()

			if ( 'notification' == $( '.guest-switcher' ).data( 'target' ) )
				$( '.guest-switcher' ).show()
			else
				$( '.guest-switcher' ).hide()


	##
	# Submit guest watch form
	##
	submitGuestWatch: ->
		$( '.woocommerce-form-guest' ).on 'click', '.guest-watch', ( e ) =>
			e.preventDefault()

			$email      = $( '#guest_email' ).val()
			$nonce      = $( 'input[name="wc-product-review-pro-guest-nonce"]' ).val()
			$comment_id = $( '#guest-comment-id' ).val()
			$feedback   = $( '#comment-' + $comment_id ).find( '.contribution-actions .feedback' ).html( '' )

			$.ajax
				type:   'POST'
				url:   @options.ajax_url
				data:
					action:   'wc_product_reviews_pro_guest_watch'
					security:   $nonce
					email:   $email
					comment_id:   $comment_id
				success: ( response ) =>
					if ( response.success )
						this.hideModal()

						$feedback.css( 'display', 'inline-block' )

						setTimeout( ->
							$feedback.fadeOut()
						, 2000 )

						$feedback.removeClass( 'error' )
						$feedback.text( response.data.message )
					else
						$feedback.css( 'display', 'none' )
						$feedback.text( '' )

						$( '#guest_login .woocommerce-error' ).remove()

						$( '<ul class="woocommerce-error"><li>' + response.data.message + '</li></ul>' ).insertBefore( '.woocommerce-form-guest' )


	##
	# Custom code to add more feature for review pro
	##
	customCodeFeatures: ->
		if ( $( '#review_rating_fieldset' ).length > 0 )
			$( '#review_rating_fieldset #review_rating_5' ).attr( 'checked', 'checked' )

			reviewFieldsAdjustment = () ->
				$( '#review_comment_field' ).show()
				$( '#review_rating_field' ).show()

				# rating fields should be in form at first position so it get submitted and placed correctly
				$( '#review_rating_field' ).prependTo( $( '.form-contribution.form-review' ) )

			setTimeout(reviewFieldsAdjustment, 500)

		$( '.gallery_first_image, #review_comment' ).on 'click', () =>
			$( '#review_title' ).trigger( 'click' )


		# Undefined variable wc_product_reviews_pro.i18n.extra_points and always empty
		$( '.add_own_images' ).on 'click', ( e ) =>
			e.preventDefault()
			$( window ).scrollTop( $( '.store-tabs' ).offset().top )
			$( '#review_title' ).focus()


		$( '#review_title, #review_comment_field' ).on 'click focus', ( e ) =>
			e.stopPropagation()
			# if user is logged in we remove the email and password/name field since they are already set by the account
			if ( document.cookie.indexOf( 'logged_in' ) >= 0 )
				# fixed, js error which are throws when email id and author id not found
				if ( $( '#email_field' ).length != 0 )
					document.getElementById( 'email_field' ).outerHTML = ''
					document.getElementById( 'author_field' ).outerHTML = ''

			$( '#review_block_form_wrapper' ).addClass( 'active' )
			$( '#review_attachment_url_field' ).css( 'display', 'inline-block' )
			$( '#review_attachment_file_field' ).css( 'display', 'inline-block' )
			$( '#author_field' ).css( 'display', 'inline-block' )
			$( '#email_field' ).css( 'display', 'inline-block' )
			$( '#review_or' ).css( 'display', 'inline-block' )
			$( '.show_style_point' ).css( 'display', 'inline-block' )
			$( '#submit_review' ).css( 'display', 'inline-block' )
			$( '.review-qualifiers' ).css( 'display', 'block' )
			$( '.pic_cta' ).css( 'display', 'block' )


		$( '.focuses_pass' ).on 'click', ( e ) =>
			e.preventDefault()
			$( '.focuses_pass' ).css( 'display', 'none' )
			$( '#author_field label' ).html( wc_product_reviews_pro.i18n.password_string )
			$( '#author_field input' ).attr( 'placeholder', wc_product_reviews_pro.i18n.password_string )
			$( '#author_field input' ).attr( 'type', 'password' )
			$( '#author_field input' ).attr( 'name', 'password' )
			$( '#author_field input' ).attr( 'x-autocompletetype', 'password' )
			$( '#author_field input' ).attr( 'autocompletetype', 'password' )
			$( '#author_field input' ).attr( 'autocomplete', 'password' )
			$( '#author_field' ).css( 'display', 'inline-block' )


		# review-dot click event
		$( '.review-dot' ).on 'click', ( e ) =>
			$elem = $( e.currentTarget )
			$current_id = $elem.data( 'qualifier_id' )
			$( '.' + $current_id ).removeClass( 'selected' )
			$elem.addClass( 'selected' )


		if ( $( 'body' ).hasClass( 'single-product' ) )
			$( '.review-qualifier-dropdown select' ).select2({
			minimumResultsForSearch: -1
			})


		# review validation of email and not login user
		$( '#submit_review' ).on 'click', () =>
			if ( $( '#email' ).val() == '' )
				$( '#error_comment' ).show()
				return false

			# by localize object we can easily check that user is logged or not.
			if ( wc_product_reviews_pro.is_user_logged_in == '' )
				isValidEmailAddress = ( emailAddress ) ->
					pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i
					return pattern.test(emailAddress)

				if ( !isValidEmailAddress( $( '#email' ).val() ) )
					$( '#error_comment_email' ).show()
					return false

			if ( $( '#author' ).val() == '' )
				$( '#error_comment' ).show()
				return false

			review_attachment_url = $( '#review_attachment_url' ).val()
			if ( review_attachment_url )
				is_valid_review_url = ( review_attachment_url ) ->
					ext = review_attachment_url.split( '.' ).pop().toLowerCase()
					if ( $.inArray( ext, [ 'jpg', 'jpeg', 'gif', 'png', 'webp', 'mp4', 'webm' ]) == -1 )
						return false
					else
						return true

				# Validation for review url so it only has any of the type '.jpg', '.jpeg', '.gif', '.png', '.webp', '.mp4', '.webm'
				if ( !is_valid_review_url( review_attachment_url ) )
					$( '#error_comment_attachment_url' ).show()
					return false


# Kick-off
jQuery ( $ ) ->
	new WC_Product_Reviews_Pro( window.wc_product_reviews_pro )
